import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-send-email-success-modal',
  templateUrl: './send-email-success-modal.component.html',
  styleUrls: ['./send-email-success-modal.component.scss'],
})
export class SendEmailSuccessModalComponent implements OnInit {
  tenant: string = '';
  merchant: string = '';
  constructor(
    private readonly router: Router,
    private merchantService: MerchantService,
    private readonly route: ActivatedRoute,
    private readonly modalService: BoobleModalService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
    this.merchant = this.merchantService.getLoginMerchant(this.tenant);
  }

  goToLogin() {
    this.modalService.dismiss(null);
    this.router.navigateByUrl(`${this.tenant}/login?m=${this.merchant}`);
  }
}
